export default __webpack_public_path__ + "static/media/exit.b1dff869.svg";